var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-box"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }